import * as React from 'react';

import { IArticle } from '../types';
import { renderArticle } from './StaticPages';

export interface ILegalsContentProps {
  articles: IArticle[];
}

export const LegalsContent: React.FC<ILegalsContentProps> = ({ articles }) => {
  const hasArticles = !!articles && articles.length > 0;
  return hasArticles ? articles.map(renderArticle) : null;
};

export default LegalsContent;
